export const environment = {
  production: true,
  nonprod: false
};
